//------------------------------------------------------------------------------
// name: bankcard.ts
// author: mudas
// created: 2025/12/03
//------------------------------------------------------------------------------

import creditCardType from 'credit-card-type';
import type { CreditCardType } from 'credit-card-type/dist/types';

export interface BankCardFormatOptions {
  mask?: boolean;
  maskChar?: string;
  maskLength?: number;
}

const prettyCardNumber = (cardNumber: string, card?: CreditCardType) => {
  if (card) {
    const offsets = ([] as number[]).concat(0, card.gaps, cardNumber.length);
    const components: string[] = [];

    for (let i = 0; offsets[i] < cardNumber.length; i++) {
      const start = offsets[i];
      const end = Math.min(offsets[i + 1], cardNumber.length);
      components.push(cardNumber.substring(start, end));
    }

    return components.join(' ');
  }

  return cardNumber;
};

export const formatBankCard = (cardNumber: string, options: BankCardFormatOptions = {}): string => {
  const { mask, maskChar = '•' } = options;

  const cardTypes = creditCardType(cardNumber);

  if (cardTypes.length === 0) {
    // 无法识别的卡类型，使用默认格式
    return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  }

  const cardType = cardTypes[0];
  let formatted = prettyCardNumber(cardNumber, cardType);

  if (mask) {
    const parts = formatted.split(' ');
    if (parts.length > 2) {
      const firstPart = parts[0];
      const lastPart = parts[parts.length - 1];
      const maskedParts = parts.slice(1, -1).map((part) => maskChar.repeat(part.length));
      formatted = [firstPart, ...maskedParts, lastPart].join(' ');
    }
  }

  return formatted;
};
